import { Box, Typography, type SxProps, type Theme } from '@mui/material'
import type { ReactNode } from 'react'

type PageHeaderProps = Readonly<{
  title: string
  action?: ReactNode
  sx?: SxProps<Theme>
}>

export function PageHeader({ title, action, sx }: PageHeaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 3,
        ...sx,
      }}
    >
      <Typography variant="h5">{title}</Typography>
      {action && <Box>{action}</Box>}
    </Box>
  )
}
